import { withNamespaces } from "react-i18next";
import { useMemo, useState } from "react";
import {
    Col,
    Container,
    Row
} from 'reactstrap';
import { useParams, useHistory, useLocation } from "react-router-dom";
import Navigator from "src/components/Navigator";
import AlertBody from "./components/alert-body";

const AlertDetailPage = ({ t }) => {
    const history = useHistory();
    const params = useParams();
    const location = useLocation();
    const [itemName, setItemName] = useState('...');

    const navigatorOptions = useMemo(() => {
        return {
            translate: false,
            backButtonOptions: () => {
                return {
                    enable: true,
                    title: t("Back"),
                    icon: <i className="ri-arrow-left-fill"></i>,
                    onClick: () => history.goBack() 
                }
            },
            breadCrumbs: [
                {
                    title: t("SIP"),
                    link: "/admin/3rd-party/dashboard"
                },
                {
                    title: "Compliance Monitoring",
                    link: "/admin/3rd-party/compliance/monitoring?tab=dashboard"
                },
                {
                    title: t("Overview"),
                    link: "/admin/3rd-party/compliance/monitoring?tab=overview"
                },
                {
                    title: t("Detail"),
                    link: "#"
                }
            ],
            pageTitle: itemName
        }
    }, [ t, history, itemName ]);

    const searchParams = new URLSearchParams(location.search);

    return (
        <div className="page-content">
            <Container fluid>
                <Row>
                    <Col lg="12" className="mb-4">
                        <Navigator {...navigatorOptions} />
                    </Col>

                    <Col lg="12" className="mb-4">
                        <AlertBody
                            id={params.id}
                            type={searchParams.get('type')}
                            supplierId={searchParams.get('supplierId')}
                            onItemNameChange={setItemName}
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default withNamespaces()(AlertDetailPage);